<template>
  <div class="agenda">
    <div class="menu-bar">
      <header>
        <nav class="navbar navbar-default">
          <div class="container special">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle collapsed"
                @click="onIshow()"
              >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a
                class="navbar-brand"
                href="http://www.futureprize.org/cn/index.html"
              >
                <img src="../assets/logo.png" alt="" />
              </a>
            </div>
            <div
              class="collapse navbar-collapse"
              id="bs-example-navbar-collapse-1"
              :style="{ display: show ? 'block' : 'none' }"
            >
              <ul class="nav navbar-nav navbar-right">
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/index.html#agenda"
                    >Agenda</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/index.html#academic_guidance"
                    >Academic Advisors</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/index.html#registration_for_the_conference"
                    >Registration</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/index.html#partners"
                    >Partners</a
                  >
                </li>
                <li>
                  <a href="http://www.futureprize.org/pages/en/index.html#/"
                    >Live</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/our-legacy.html"
                    >Our Legacy</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/volunteer.html"
                    >Volunteer</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.futureprize.org/en/prize-week/index.html#contactus"
                    >Contact Us</a
                  >
                </li>
                <li>
                  <a href="http://www.futureprize.org/cn/prize-week/index.html?prizeWeekId=3"
                    >CN</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </div>

    <div class="big-prize">
      <div
        style="
          position: absolute;
          left: 50%;
          top: 80px;
          transform: translate(-50%, 0);
        "
      >
        <iframe
          :src="videoUrl"
          class="picture"
          poster=""
          controls="controls"
          x5-video-player-fullscreen="false"
          allowfullscreen="false"
          ref="video"
        ></iframe>
      </div>
    </div>
    <div style="margin: 0 27.5px">
      <div class="future">
        <h1>2020 Future Science Prize Week</h1>
        <div class="text">12/27 – 12/30</div>
      </div>
      <el-table
        :data="tableData"
        stripe
        style="width: 1170px"
        :header-cell-style="{ background: '#fafafa', color: '#606266' }"
      >
        <el-table-column prop="date" label="日期" width="100">
        </el-table-column>
        <el-table-column prop="time" label="时间" width="120">
        </el-table-column>
        <el-table-column prop="address" label="议程">
          <template slot-scope="scope">
            <i
              class="el-icon-video-play icon"
              @click="handleClick(scope.row)"
            ></i
            ><span
              @click="handleClick(scope.row)"
              :class="{ color: activeColor == scope.row.id }"
              >{{ scope.row.address }}</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <footer>
      <span
        >&copy;FuturePrize.org 未来科学大奖主办单位 京ICP备16046684号-1</span
      >
    </footer>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      videoUrl: "https://v.qq.com/txp/iframe/player.html?vid=a32187bzfoo",
      isColor: true,
      activeColor: 0,
      //下拉菜单的内容的显示和隐藏
      show: false,
      tableData: [
        {
          date: "12/27",
          time: "09:30 - 12:00",
          address: "Future Science Prize Week Opening Ceremony",
          id: 1,
        },
        {
          date: "12/27",
          time: "12:00 - 17:00",
          address: "Where Are the Women Scientists",
          id: 2,
        },
        {
          date: "12/27",
          time: "19:30 - 22:30",
          address: "Virus and Human Health Forum",
          id: 3,
        },
        {
          date: "12/28",
          time: "09:30 - 18:00",
          address:
            "Education-Research-Innovation Forum: Education-Research-Innovation Dialogue",
          id: 4,
        },
        {
          date: "12/28",
          time: "11:00 - 12:30",
          address:
            "Education-Research-Innovation Forum: Dialogues between Investors and Scientist Entrepreneurs",
          id: 5,
        },
        {
          date: "12/28",
          time: "14:00 - 15:30",
          address:
            "Panel Discussion: Intelligent IOT and Digital Transformation of Industry",
          id: 6,
        },
        {
          date: "12/28",
          time: "15:30 - 18:00",
          address:
            "Panel Discussion: Education-Research-Innovation Cooperation in the Digital Era",
          id: 7,
        },
        {
          date: "12/29",
          time: "14:00 - 15:30",
          address:
            "Discussions with Young Scientists: Social Responsibility of AI Technology",
          id: 8,
        },
        {
          date: "12/29",
          time: "15:30 - 17:00",
          address:
            "Discussions with Young Scientists: Industrial Digital Transformation",
          id: 9,
        },
        {
          date: "12/29",
          time: "19:30 - 22:00",
          address: "Innovations by Young Scientists",
          id: 10,
        },
        {
          date: "12/30",
          time: "09:00 - 12:00",
          address: "Future Science Prize Lecture in Life Science",
          id: 11,
        },
        {
          date: "12/30",
          time: "13:00 - 17:00",
          address:
            "Future Science Prize Lecture in Mathematics and Computer Science",
          id: 12,
        },
        {
          date: "12/30",
          time: "17:30 - 19:00",
          address:
            "Future Dialogue: K12 Students and the Future Science Prize 2020 - Mathematics and Computer Science Prize Laureate",
          id: 13,
        },
        {
          date: "12/30",
          time: "19:30 - 22:00",
          address: "Future Science Prize Award Ceremony",
          id: 14,
        },
      ],
      videoArr: [
        "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
        "https://v.qq.com/txp/iframe/player.html?vid=g32168cprs2",
        "https://v.qq.com/txp/iframe/player.html?vid=v32165dvnay",
        "https://v.qq.com/txp/iframe/player.html?vid=f3216wleik0",

        "https://v.qq.com/txp/iframe/player.html?vid=p3216davurw",
        "https://v.qq.com/txp/iframe/player.html?vid=z3216nm6c2j",
        "https://v.qq.com/txp/iframe/player.html?vid=c3216qv858w",
        "https://v.qq.com/txp/iframe/player.html?vid=t3216nji0w4",

        "https://v.qq.com/txp/iframe/player.html?vid=w3216bxp975",
        "https://v.qq.com/txp/iframe/player.html?vid=v3216s9eslt",
        "https://v.qq.com/txp/iframe/player.html?vid=a3216n3arhz",
        "https://v.qq.com/txp/iframe/player.html?vid=y32177l072u",

        "https://v.qq.com/txp/iframe/player.html?vid=u3217dy42d4",
        "https://v.qq.com/txp/iframe/player.html?vid=a32187bzfoo",
      ],
    };
  },
  mounted() {},
  methods: {
    handleClick(row) {
      this.videoUrl = this.videoArr[row.id - 1];
      this.activeColor = row.id;
      console.log(row.id);
    },
    //下拉菜单的事件
    onIshow() {
      this.show = this.show ? false : true;
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.List {
  height: 0;
  animation: move 0.2s;
}
@keyframes move {
  0% {
    height: 10vh;
  }
  25% {
    height: 25vh;
  }
  50% {
    height: 50vh;
  }
  75% {
    height: 75vh;
  }
  100% {
    height: 100vh;
  }
}
.menu-bar {
  width: 100%;
  height: 50px;
  background: #000;
  position: fixed;
  top: 0;
  z-index: 99;
}
.special {
  padding-right: 10px;
  .navbar-brand {
    padding: 5px;
    img {
      width: 170px;
      height: 40px;
      margin: 3px 10px 0;
    }
  }
}
.navbar-default .navbar-nav > li > a {
  color: #fff;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #fff;
}
/deep/.el-table {
  // border: 1px solid #ccc;
  margin: 0 auto 70px;
  td,
  th {
    padding: 5px 0;
  }
  .icon {
    margin-right: 10px;
  }
}

.big-prize {
  width: 100%;
  height: 660px;
  // background: url("../assets/videobgc.jpg");
  background-size: 100% 100%;
  // padding-top: 20px;
  margin-top: 80px;
}
.future {
  height: 100px;
  background-color: #fff;
  color: #666;
  h1 {
    text-align: center;
    padding: 10px 0 10px;
    // font-weight: 700;
    font-size: 20px;
  }
  .text {
    text-align: center;
    // font-weight: 700;
  }
}
.color {
  color: blue;
}
.picture {
  background: #000000;
  border: none;
  width: 1170px;
  height: 660px;
}
footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 46px;
  line-height: 46px;
  background-color: #f6f4f5;
  color: #999;
  margin-top: 46px;
  span {
    padding-left: 30px;
    font-size: 14px;
  }
}
@media screen and (max-width: 414px) {
  .header_table {
    ul {
      li {
        margin-right: 0px;
      }
    }
  }

  .big-prize {
    width: 354px;
    height: 210px;
    .picture {
      background: #000000;
      border: none;
      width: 354px;
      height: 196px;
    }
  }
  footer {
    width: 410px;
    height: 46px;
    line-height: 46px;
    background-color: #f6f4f5;
    color: #999;
    white-space: normal;
    overflow: hidden;
    span {
      display: block;
      padding-left: 0px;
      padding-right: 0;
      font-size: 13px;
      text-align: center;
    }
  }
  .navbar-brand {
    padding: 15px 0;
    img {
      width: 110px !important;
      height: 25px !important;
      margin: 8px 10px 0 !important;
    }
  }
}
@media screen and (max-width: 375px) {
  .menu-bar {
    width: 375px;
  }
  .big-prize {
    width: 320px;
    height: 200px;
    .picture {
      border: none;
      width: 320px;
      height: 188px;
    }
  }
  footer {
    width: 375px;
    height: 46px;
    line-height: 46px;
    background-color: #f6f4f5;
    color: #999;
    span {
      display: block;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 12px;
      text-align: center;
    }
  }
  .navbar-default .navbar-collapse,
  .navbar-default .navbar-form {
    height: 100vh;
  }
  .navbar-brand {
    padding: 15px 0;
    img {
      width: 110px !important;
      height: 25px !important;
      margin: 8px 10px 0 !important;
    }
  }
}

.navbar-default {
  margin: 0;
  background-color: #000;
  border: 0;
  .navbar-toggle {
    border: 1px solid #000;
  }
  .navbar-toggle:hover {
    background-color: #000;
  }
  .navbar-nav {
    li {
      a:hover {
        color: #c8a971;
      }
    }
  }
  .navbar-collapse {
    border-top: 0;
  }
}
//屏幕375点击下拉的高度
</style>
